import { Theme } from '@mui/material/styles'
export const styles = {
  appBar: {
    backgroundColor: (theme: Theme) => theme.palette.common.white,
  },

  branchesDetails: {
    fontSize: 14,
    color: (theme: Theme) => theme.palette.text.primary,
    marginTop: (theme: Theme) => theme.spacing(1.5),
    marginLeft: (theme: Theme) => theme.spacing(2),
  },

  button: { height: '50px' },

  helperText: {
    color: (theme: Theme) => theme.palette.text.primary,
    fontFamily: 'Source Sans Pro',
    fontSize: '12px',
    marginBottom: (theme: Theme) => theme.spacing(1),
    maxWidth: '700px',
  },

  tab: {
    padding: (theme: Theme) => `0 ${theme.spacing(4)}`,
    whiteSpace: 'nowrap',
  },

  tabPanel: {
    padding: (theme: Theme) => theme.spacing(2.4),
  },
}
